let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9dm7L")).then(() => parcelRequire('3ybaR'));